import React, {useContext, useEffect, useState} from "react";
import { StockContext } from "./stock_context";
import Stockchart from "../stockchart_plotly";
import DisplayCards from "../metricCards";
import DynamicStockCharts from "../dynamicStockCharts_plotly";
import FundaTeaser from "../fundamentals/stockFundamentalTeaser";
import Plot from "react-plotly.js";
import {fetchStockFundamentals, fetchStockTechnicals} from "../../api";
import {useNavigate} from "react-router-dom";

function Summary({symbol}) {
    return(
        <div>
        <FundaTeaser symbol={symbol}/>
        </div>
    );
}

const transformData = (data) => {
 // Extract the latest available date dynamically
 const availableDates = Object.values(data)
  .map(item => Object.keys(item).filter(key => key !== "change"))
  .flat();

 const latest = availableDates.length ? availableDates[0] : null;
  const totalAssets = parseFloat(data["Assets"]?.[latest]) || 0;
  console.log("latestDate",latest,totalAssets)
  // Extract all keys except "Assets"
  const assetKeys = Object.keys(data).filter(key => key !== "Assets");

  // Calculate individual asset values
  const transformedList = assetKeys.map(key => ({
    title: key,
    value: parseFloat(data[key][latest]) || 0
  }));

  // Calculate "Others" as Total Assets - Sum of other asset categories
  const sumOfKnownAssets = transformedList.reduce((sum, item) => sum + item.value, 0);
  const otherAssets = totalAssets - sumOfKnownAssets;

  // Include "Others" if it's greater than zero
  if (otherAssets > 0) {
    transformedList.push({ title: "Others", value: otherAssets });
  }

  return transformedList;
};
const AssetDonutChart = ({ assetList }) => {
  // Extracting labels and values from assetList
  const labels = assetList.map((item) => item.title);
  const values = assetList.map((item) => item.value);

  return (
    <Plot
      data={[
        {
          labels: labels,
          values: values,
          type: "pie",
          hole: 0.4, // Creates the donut effect
          marker: {
            colors: ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#A569BD"],
          },
          textinfo: "label+percent",
          hoverinfo: "label+value",
        },
      ]}
      layout={{
        title: "Asset Allocation",
        height: 400,
        width: 400,
        showlegend: false,
      }}
    />
  );
};

const StackedBarChart = ({ rawData, approvedMetrics,title }) => {
  // Extract column names (excluding "index")
  console.log("RECEIEVD RAWDATA",rawData);

  const columnNames = rawData.columns.slice(1); // ["2024-06-30", "2024-03-31"]

  // Filter metrics based on the approved list
  const filteredData = rawData.data.filter((item) => approvedMetrics.includes(item[0]));

  // Convert values to float and sort data in ascending order based on the first date column
  const sortedData = filteredData
    .map((item) => [item[0], ...item.slice(1).map((val) => parseFloat(val) || 0)]) // Convert to float, default 0 if NaN
    .sort((a, b) => a[1] - b[1]); // Sort by first column values
  console.log("RECEIEVD sortedData",sortedData);

  // Extract metric names from filtered data
  const metrics = sortedData.map((item) => item[0]); // Approved metric names

  // Convert data into Plotly format
  const traces = columnNames.map((date, idx) => ({
    x: metrics, // X-axis: Filtered metric names
    y: sortedData.map((item) => item[idx + 1]), // Extract corresponding Y-values
    name: date, // Legend name
    type: "bar",
    marker: { opacity: 0.8 },
  }));

  return (
    <Plot
      data={traces}
      layout={{
        title: title,
       xaxis: { //title: "Metrics",
           tickangle: -30 },
        yaxis: { title: "Values", autorange: true }, // Auto scales to fit
        margin: { l: 60, r: 10, t: 40, b: 100 },
        barmode: "group", // Ensures separate bars
      }}
      // style={{ width: "100%", height: "500px" }}
    />
  );
};

const PnLSummary = ({data}) => {

  const [metrics, setMetrics] = useState({});
  const [ratio_metrics, setRatioMetrics] = useState({});
  const [pnl_metrics, setPnlMetrics] = useState({});
  const [asset_metrics, setAssetMetrics] = useState({});
  const [metricListPie, setMetricListPie] = useState({});
  const [metricListSl, setMetricListSl] = useState({});
  const [detailData, setDetailData] = useState({});
  const [allowedMetricsForPie, setAllowedMetricsForPie] = useState({});

  const [latestDate, setLatestDate] = useState(null);
  const navigate = useNavigate();

 useEffect(() => {
    // fetch(url)  // Adjust API URL as needed
    //   .then(response => response.json())
    //  fetchStockFundamentals(symbol,'all')
    //   .then(data => {
        if (!data || !data.Metric) {
          console.error("Invalid response format");
          return;
        }

        setDetailData(data.detailed_data);
        const metricEntries = Object.entries(data.Metric);
        if (metricEntries.length === 0) {
          console.error("No metric data available");
          return;
        }

        // Extract the latest available date dynamically
        const availableDates = Object.values(data.Metric)
          .map(item => Object.keys(item).filter(key => key !== "change"))
          .flat();

        const latest = availableDates.length ? availableDates[0] : null;
        setLatestDate(latest);

        // Convert API data into a list format
        const allowedMetricsForCard = ['Basic EPS', 'Debt Equity Ratio','Profit Loss','Interest Service Coverage Ratio','Debt Service Coverage Ratio'];
        const allowedMetricsForPie = ['Current Assets', 'Fixed Assets','Goodwill','Investments','Advances','Assets'];
        setAllowedMetricsForPie(allowedMetricsForPie);
        const metricList = Object.entries(data.Metric)
            .filter(([title]) => allowedMetricsForCard.includes(title)) // Filter only allowed titles
            .map(([title, data]) => ({
          title,
          value: data[latest], // Extract the latest available value
          change: data.change
        }));
        setMetrics(metricList);

        let metricListPie = Object.fromEntries(
                  Object.entries(data.Asset).filter(([key]) => allowedMetricsForPie.includes(key))
                );
        console.log("BEFORE",metricListPie);

        metricListPie = transformData(metricListPie);
        console.log("AFTER",metricListPie);
        setMetricListPie(metricListPie);

        let metricListEPS = JSON.parse(data.detailed_data).data[0].splice(1);
        metricListEPS = metricListEPS.map(parseFloat)
        setMetricListSl(metricListEPS);
        console.log("metricListEPS",metricListEPS);
      // })
      // .catch(error => console.error("Error fetching data:", error));
  }, [data]);



return (

    <div style={styles.teaserBoard}>
    {/*<div >*/}
        {/*<div style={styles.metricSection}>*/}
            <DisplayCards cardList={metrics}/>
        {/*</div>*/}

        <div>
            {detailData.length > 0 ?
            <StackedBarChart rawData={JSON.parse(detailData)} approvedMetrics={["Total Revenue","Revenue","Other Income"]} title={"Revenue Evolution"}/>
                : ""}
        </div>
    </div>
);
}

const AssetSummary = ({data}) => {

  const [metrics, setMetrics] = useState({});
  const [ratio_metrics, setRatioMetrics] = useState({});
  const [pnl_metrics, setPnlMetrics] = useState({});
  const [asset_metrics, setAssetMetrics] = useState({});
  const [metricListPie, setMetricListPie] = useState({});
  const [metricListSl, setMetricListSl] = useState({});
  const [detailData, setDetailData] = useState({});
  const [allowedMetricsForPie, setAllowedMetricsForPie] = useState({});

  const [latestDate, setLatestDate] = useState(null);
  const navigate = useNavigate();

 useEffect(() => {
    // fetch(url)  // Adjust API URL as needed
    //   .then(response => response.json())
    //  fetchStockFundamentals(symbol,'all')
    //   .then(data => {
        if (!data || !data.Metric) {
          console.error("Invalid response format");
          return;
        }

        setDetailData(data.detailed_data);
        const metricEntries = Object.entries(data.Metric);
        if (metricEntries.length === 0) {
          console.error("No metric data available");
          return;
        }

        // Extract the latest available date dynamically
        const availableDates = Object.values(data.Metric)
          .map(item => Object.keys(item).filter(key => key !== "change"))
          .flat();

        const latest = availableDates.length ? availableDates[0] : null;
        setLatestDate(latest);

        // Convert API data into a list format
        const allowedMetricsForCard = ['Basic EPS', 'Debt Equity Ratio','Profit Loss','Interest Service Coverage Ratio','Debt Service Coverage Ratio'];
        const allowedMetricsForPie = ['Current Assets', 'Fixed Assets','Goodwill','Investments','Advances','Assets'];
        setAllowedMetricsForPie(allowedMetricsForPie);
        const metricList = Object.entries(data.Metric)
            .filter(([title]) => allowedMetricsForCard.includes(title)) // Filter only allowed titles
            .map(([title, data]) => ({
          title,
          value: data[latest], // Extract the latest available value
          change: data.change
        }));
        setMetrics(metricList);

        let metricListPie = Object.fromEntries(
                  Object.entries(data.Asset).filter(([key]) => allowedMetricsForPie.includes(key))
                );
        console.log("BEFORE",metricListPie);

        metricListPie = transformData(metricListPie);
        console.log("AFTER",metricListPie);
        setMetricListPie(metricListPie);

        let metricListEPS = JSON.parse(data.detailed_data).data[0].splice(1);
        metricListEPS = metricListEPS.map(parseFloat)
        setMetricListSl(metricListEPS);
        console.log("metricListEPS",metricListEPS);
      // })
      // .catch(error => console.error("Error fetching data:", error));
  }, [data]);



return (

    // <div style={styles.teaserBoard}>
    <div >
        {/*<div style={styles.metricSection}>*/}
            <DisplayCards cardList={metrics}/>
        {/*</div>*/}

        <div style={styles.chartsSection}>
            {/*<div>*/}
            {metricListPie.length > 0 ?
            <AssetDonutChart assetList={metricListPie}/>
                : ""}
            {/*{metricListSl.length > 0 ?*/}
            {/*<Sparklines data={metricListSl}>*/}
            {/*            <SparklinesLine color="blue" />*/}
            {/*</Sparklines>*/}
            {/* : ""}*/}
        </div>
        <div>
            {detailData.length > 0 ?
            <StackedBarChart rawData={JSON.parse(detailData)} approvedMetrics={allowedMetricsForPie} title={"Asset Evolution"}/>
                : ""}
        {/*</div>*/}
        {/*<div>*/}
            {detailData.length > 0 ?
            <StackedBarChart rawData={JSON.parse(detailData)} approvedMetrics={["Equity And Liabilities","Liabilities","Current Liabilities","Non Current Liabilities"]} title={"Liability Evolution"}/>
                : ""}
        </div>
    </div>
);
}

const CFSummary = ({data}) => {

  const [metrics, setMetrics] = useState({});
  const [ratio_metrics, setRatioMetrics] = useState({});
  const [pnl_metrics, setPnlMetrics] = useState({});
  const [asset_metrics, setAssetMetrics] = useState({});
  const [metricListPie, setMetricListPie] = useState({});
  const [metricListSl, setMetricListSl] = useState({});
  const [detailData, setDetailData] = useState({});
  const [allowedMetricsForPie, setAllowedMetricsForPie] = useState({});

  const [latestDate, setLatestDate] = useState(null);
  const navigate = useNavigate();

 useEffect(() => {
    // fetch(url)  // Adjust API URL as needed
    //   .then(response => response.json())
    //  fetchStockFundamentals(symbol,'all')
    //   .then(data => {
        if (!data || !data.Metric) {
          console.error("Invalid response format");
          return;
        }

        setDetailData(data.detailed_data);
        const metricEntries = Object.entries(data.Metric);
        if (metricEntries.length === 0) {
          console.error("No metric data available");
          return;
        }

        // Extract the latest available date dynamically
        const availableDates = Object.values(data.Metric)
          .map(item => Object.keys(item).filter(key => key !== "change"))
          .flat();

        const latest = availableDates.length ? availableDates[0] : null;
        setLatestDate(latest);

        // Convert API data into a list format
        const allowedMetricsForCard = ['Basic EPS', 'Debt Equity Ratio','Profit Loss','Interest Service Coverage Ratio','Debt Service Coverage Ratio'];
        const allowedMetricsForPie = ['Current Assets', 'Fixed Assets','Goodwill','Investments','Advances','Assets'];
        setAllowedMetricsForPie(allowedMetricsForPie);
        const metricList = Object.entries(data.Metric)
            .filter(([title]) => allowedMetricsForCard.includes(title)) // Filter only allowed titles
            .map(([title, data]) => ({
          title,
          value: data[latest], // Extract the latest available value
          change: data.change
        }));
        setMetrics(metricList);

        let metricListPie = Object.fromEntries(
                  Object.entries(data.Asset).filter(([key]) => allowedMetricsForPie.includes(key))
                );
        console.log("BEFORE",metricListPie);

        metricListPie = transformData(metricListPie);
        console.log("AFTER",metricListPie);
        setMetricListPie(metricListPie);

        let metricListEPS = JSON.parse(data.detailed_data).data[0].splice(1);
        metricListEPS = metricListEPS.map(parseFloat)
        setMetricListSl(metricListEPS);
        console.log("metricListEPS",metricListEPS);
      // })
      // .catch(error => console.error("Error fetching data:", error));
  }, [data]);



return (

    <div style={styles.teaserBoard}>
    {/*<div >*/}
        {/*<div style={styles.metricSection}>*/}
            <DisplayCards cardList={metrics}/>
        {/*</div>*/}
    </div>
);
}

const FundamentalAnalysis = ({stockSymbol}) => {
  // const stockData = useContext(StockContext);
  const [fundaData, setFundaData] = useState(null);
  const subSections = ["Summary", "Revenue & Profit", "Balance Sheet", "Cash Flow"];
  const [activeSubTab, setActiveSubTab] = useState(subSections[0]);
  console.log("SUMMARY DATA  RECVD" , stockSymbol);
  // if (!stockData) return <p>Loading stock data...</p>;
  useEffect(() => {
     fetchStockFundamentals(stockSymbol,'all')
      .then(data => {
        if (!data || !data.Metric) {
          console.error("Invalid response format");
          return;
        }
        console.log("RECV DATA START",data)
        setFundaData(data);

      })
      .catch(error => console.error("Error fetching data:", error));
  }, [stockSymbol]);

  if (!fundaData) return <p>Loading Fundamental analysis...</p>;

  const renderContent = () => {

    switch (activeSubTab) {
      case "Summary":
        return  stockSymbol ? (<div align={"center"}>
      <Summary symbol={stockSymbol}/>
            </div>) : (
                <p>Loading data...</p>
              );
      case "Revenue & Profit":
        return fundaData ? (<div align={"center"} style={{height:"700px"}}>
            <PnLSummary data={fundaData}/>
                </div>): (
                <p>Loading data...</p>
              );
      case "Balance Sheet":
        return fundaData ? (<div align={"center"} style={{height:"700px"}}>
            <AssetSummary data={fundaData}/>
                </div>) : (
                <p>Loading data...</p>
              );
      case "Cash Flow":
        return fundaData ? (<div align={"center"}>
        {/*<Risk data={JSON.parse(data.risk_list)} ticker={data.symbol}/>*/}
            <CFSummary data={fundaData}/>
        </div>) : (
                <p>Loading data...</p>
              );
      default:
        return <div>Select a tab to view content.</div>;
    }
  };

  return (
    <div className="section-container">
      {/* Vertical Sidebar */}
      <div className="sidebar">
        {subSections.map((tab) => (
          <button
            key={tab}
            className={`side-tab ${activeSubTab === tab ? "active" : ""}`}
            onClick={() => setActiveSubTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Content Display */}
      <div className="content">
        {/*<h2>{activeSubTab}</h2>*/}
        {/*<p>Displaying data for {activeSubTab}...</p>*/}
        {renderContent()}
      </div>
    </div>
  );
};

export default FundamentalAnalysis;

const styles = {
  teaserBoard: {
    display: "flex",
    flexWrap: "wrap",
    gap: "16px",
    // justifyContent: "space-between",
    flexDirection: "column", // Ensures elements stack vertically
    alignItems: "center", // Centers all child elements
    justifyContent: "center",
    width: "100%",
    padding: "20px",
    background: "#f8f9fa",
    borderRadius: "12px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  },
  metricSection: {
    display: "flex",
    flexWrap: "wrap",
    gap: "16px",
    flex: 2,
  },
  metricCard: {
    flex: "1 1 calc(33.33% - 16px)", // 3 cards per row
    minWidth: "200px",
    padding: "12px",
    borderRadius: "8px",
    background: "white",
    boxShadow: "2px 2px 8px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
    fontSize: "14px",
  },
  positive: {
    backgroundColor: "#e6f7e6", // Light green for positive change
  },
  negative: {
    backgroundColor: "#fce8e8", // Light red for negative change
  },
  chartsSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
    flexWrap: "wrap",
    marginBottom: "20px", // Creates space before the button
  },
    viewMore: {
    display: "flex",
    justifyContent: "center", // Centers the button horizontally
    alignItems: "center",
    marginTop: "20px", // Space from content above
    width: "100%", // Ensure it spans full width of container
  },
  viewMoreButton: {
    background: "#007bff",
    color: "#fff",
    padding: "10px 20px",
    width:"20%"  ,
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    transition: "background 0.3s",
  },
  viewMoreButtonHover: {
    background: "#0056b3",
  },
};
